<template>
  <div class="portfolio-case-study container" id="trofi">
    <CsVideoIntro v-bind="project.caseStudy.intro"></CsVideoIntro>
    <CsSynopsis v-bind="project.caseStudy.synopsis"></CsSynopsis>
    <CsShowcase v-bind="project.caseStudy.showcase"></CsShowcase>
    <CsVideoReel :video="project.caseStudy.fullVideo" />
    <CsImageGrid
      @loaded="mountTrigger"
      v-bind="project.caseStudy.imageGrid1"
    ></CsImageGrid>
    <CsImageGrid
      @loaded="mountTrigger"
      fullWidth
      v-bind="project.caseStudy.imageGrid2"
    ></CsImageGrid>

    <!-- <div class="cs-project-credits">
			<div class="cs-project-credits-content">
				<h3>Project Credits & Details</h3>
				<ul>
					<li>
						<span>Associated Agency</span>
						<span>Architecto omnis quibusdam ab corrupti quam</span>
					</li>
					<li>
						<span>Assistant Jr. Developer</span>
						<span>Nelson Khiev</span>
					</li>
					<li>
						<span>Assistant Jr. Developer</span>
						<span>Nelson Khiev</span>
					</li>
					<li>
						<span>Assistant Jr. Developer</span>
						<span>Nelson Khiev</span>
					</li>
				</ul>
			</div>
		</div> -->
    <CallToAction v-if="mountReady" v-bind="cta" />
  </div>
</template>

<script>
import { heart2heart, cta } from "@/data/projects.js";
import CallToAction from "@/components/CallToAction";
import CsVideoIntro from "@/components/CsVideoIntro/CsVideoIntro";
import CsSynopsis from "@/components/CsSynopsis/CsSynopsis";
import CsShowcase from "@/components/CsShowcase/CsShowcase";
import CsImageGrid from "@/components/CsImageGrid/CsImageGrid";
import CsVideoReel from "@/components/CsVideoReel/CsVideoReel";

export default {
  name: "Heart2Heart",
  metaInfo: {
    title: `Heart2Heart`,
    meta: [
      {
        name: "description",
        content: `A campaign concept to create and promote a campaign to raise awareness and registration for Organ Donation.`,
      },
    ],
  },
  data() {
    return {
      project: heart2heart,
      mountReady: false,
      cta: cta,
    };
  },
  components: {
    CallToAction,
    CsVideoIntro,
    CsSynopsis,
    CsShowcase,
    CsImageGrid,
    CsVideoReel,
  },
  methods: {
    mountTrigger(val) {
      this.mountReady = val;
    },
  },
};
</script>
